/**
 * FieldConfigPanel Component
 *
 * Dispatcher component that routes to the appropriate field config panel
 * based on the field type.
 */

import React from 'react';
import { FieldConfigPanelProps } from '../Fields/types';
import TextFieldConfigPanel from './TextFieldConfigPanel';
import IntegerFieldConfigPanel from './IntegerFieldConfigPanel';
import DecimalFieldConfigPanel from './DecimalFieldConfigPanel';
import FractionFieldConfigPanel from './FractionFieldConfigPanel';
import BooleanFieldConfigPanel from './BooleanFieldConfigPanel';
import RangeFieldConfigPanel from './RangeFieldConfigPanel';
import MultiChoiceFieldConfigPanel from './MultiChoiceFieldConfigPanel';
import {
  TextFieldConfig,
  IntegerFieldConfig,
  DecimalFieldConfig,
  FractionFieldConfig,
  BooleanFieldConfig,
  RangeFieldConfig,
  MultiChoiceFieldConfig,
} from '../../config/fieldDefaults';
import { normalizeFieldType } from '../../utils/normalizeFieldType';

export const FieldConfigPanel = ({
  fieldType,
  config,
  onChange,
}: FieldConfigPanelProps) => {
  // Normalize fieldType to handle variations like "Multi-choice" → "multichoice"
  const normalizedFieldType = normalizeFieldType(fieldType);

  switch (normalizedFieldType) {
    case 'text':
      return (
        <TextFieldConfigPanel
          config={config as unknown as TextFieldConfig}
          onChange={(c) => onChange(c as unknown as Record<string, unknown>)}
        />
      );
    case 'integer':
      return (
        <IntegerFieldConfigPanel
          config={config as unknown as IntegerFieldConfig}
          onChange={(c) => onChange(c as unknown as Record<string, unknown>)}
        />
      );
    case 'decimal':
      return (
        <DecimalFieldConfigPanel
          config={config as unknown as DecimalFieldConfig}
          onChange={(c) => onChange(c as unknown as Record<string, unknown>)}
        />
      );
    case 'fraction':
      return (
        <FractionFieldConfigPanel
          config={config as unknown as FractionFieldConfig}
          onChange={(c) => onChange(c as unknown as Record<string, unknown>)}
        />
      );
    case 'boolean':
      return (
        <BooleanFieldConfigPanel
          config={config as unknown as BooleanFieldConfig}
          onChange={(c) => onChange(c as unknown as Record<string, unknown>)}
        />
      );
    case 'range':
      return (
        <RangeFieldConfigPanel
          config={config as unknown as RangeFieldConfig}
          onChange={(c) => onChange(c as unknown as Record<string, unknown>)}
        />
      );
    case 'multichoice':
      return (
        <MultiChoiceFieldConfigPanel
          config={config as unknown as MultiChoiceFieldConfig}
          onChange={(c) => onChange(c as unknown as Record<string, unknown>)}
        />
      );
    default:
      return (
        <div className="tw-p-4">
          <p className="tw-text-sm tw-text-ink-secondary">
            Unknown field type: {fieldType} (normalized: {normalizedFieldType})
          </p>
        </div>
      );
  }
};

export default FieldConfigPanel;
